<script>
import { mapActions, mapGetters } from "vuex";
import AlertError from "@/components/alert_error";
import Loader from "@/components/widgets/loader";
import { swal } from "../../../helpers/handle_error";

import html2canvas from "html2canvas";
import jsPDF from "jspdf";

import { required } from "vuelidate/lib/validators"; // for validators

export default {
  components: { AlertError, Loader },
  data() {
    return {
      //Page errors.
      errors: [],
      showLoader: true,
      showAlert: false,
      loadingButton: false,
      submited: false,
      tableKey: 1,
      showModel: false,

      status: "",
      statusClassList: {
        PENDING: "bg-warning",
        REJECTED: "bg-danger",
        ACCEPTED: "bg-primary",
      },
      statusFilter: "",
      requestId: 0,

      project: "",

      items: [],

      // datatable
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      totalItems: 0,
      totalItemsFiltered: 0,
      pageOptions: [10, 25, 50, 100, { value: 10000, text: "عرض 10000" }],
      filter: "",
      filterOn: [],

      sortBy: "created_at",
      sortDesc: true,

      fields: [
        {
          // A virtual column that doesn't exist in items
          label: "التسلسل",
          key: "index",
          sortable: false,
          visible: true,
          //for join datatable.
          isVirtual: true,
          name: "",
          searchable: false,
        },
        {
          label: "الاسم الثلاثي",
          key: "full_name",
          sortable: false,
          visible: true,
          isVirtual: false,
          name: "full_name",
          searchable: true,
        },
        {
          label: "اسم المشروع",
          key: "project_name",
          sortable: false,
          visible: true,
          isVirtual: false,
          name: "project_name",
          searchable: true,
        },
        // {
        //   label: "قطاع المشروع",
        //   key: "category",
        //   sortable: false,
        //   visible: true,
        //   isVirtual: false,
        //   name: "category",
        //   searchable: true,
        // },
        {
          label: "المحافظة",
          key: "address.city.title",
          sortable: false,
          visible: true,
          isVirtual: false,
          name: "address.city.title",
          searchable: true,
        },
        {
          label: "المنطقة",
          key: "address.region",
          sortable: false,
          visible: true,
          isVirtual: false,
          name: "address.region",
          searchable: true,
        },
        {
          label: "رقم الهاتف",
          key: "phone",
          sortable: false,
          visible: true,
          isVirtual: false,
          name: "phone",
          searchable: true,
        },
        {
          label: "قياس البوث",
          key: "model",
          sortable: false,
          visible: true,
          isVirtual: false,
          name: "model",
          searchable: true,
        },
        {
          label: "مكان البوث",
          key: "location",
          sortable: false,
          visible: true,
          isVirtual: false,
          name: "location",
          searchable: true,
        },
        // {
        //   label: "تاريخ تأسيس المشروع",
        //   key: "date_ini",
        //   sortable: false,
        //   visible: true,
        //   isVirtual: false,
        //   name: "date_ini",
        //   searchable: true,
        // },
        {
          label: "تاريخ التقديم",
          key: "created_at",
          sortable: false,
          visible: true,
          isVirtual: false,
          name: "created_at",
          searchable: true,
        },
        {
          label: "حالة القبول",
          key: "status",
          class: "col-acceptance-status",
          sortable: false,
          visible: true,
          //for join datatable.
          isVirtual: true,
          name: "",
          searchable: false,
        },
        {
          label: "الاجراءات",
          key: "settings",
          class: "col-setting-services-booths",
          sortable: false,
          visible: this.$store.getters["auth/getUser"].hasAnyPermission([
            "show_details_booths",
            "delete_booths",
            "update_status_booths",
          ]),
          //for join datatable.
          isVirtual: true,
          name: "",
          searchable: false,
        },
      ],
    };
  },
  // vuelidate
  validations: {
    status: { required },
  },
  computed: {
    ...mapGetters("boothsProject", ["getProjects", "getStatuses"]),
    start() {
      return this.totalItemsFiltered == 0 ? 0 : (this.currentPage - 1) * this.perPage + 1;
    },
    end() {
      return Math.min(this.currentPage * this.perPage, this.totalItemsFiltered);
    },
  },
  methods: {
    visibleFields() {
      return this.fields.filter((field) => field.visible);
    },
    handleError(error) {
      this.showAlert = true;
      const response = error.response;
      this.errors =
        response && response.status == 422 && response.data.errors
          ? Object.values(response.data.errors)
          : [
              response && response.data.message
                ? response.data.message
                : "تعذر الاتصال بالخادم، يرجى المحاولة مرة أخرى",
            ];
    },
    ...mapActions("boothsProject", ["getAll", "delete", "updateStatus", "statuses"]),
    search() {
      if (this.currentPage == 1) this.fetchAll(true);
      else this.currentPage = 1;
    },
    fetchAll(is_search) {
      const requestId = ++this.requestId;
      this.showAlert = false;
      if (!is_search) {
        this.showLoader = true;
      }

      var query = new URLSearchParams({
        draw: this.currentPage,
        start: (this.currentPage - 1) * this.perPage,
        length: this.perPage,
      });
      query.append("_datatable", "1");
      if (this.statusFilter) query.append("project_status_id", this.statusFilter);
      let columns = this.fields.filter((f) => !f.isVirtual);
      columns.forEach((el, index) => {
        query.append("columns[" + index + "][data]", el.name);
        query.append("columns[" + index + "][name]", el.name);
        query.append("columns[" + index + "][orderable]", el.name == "created_at");
        query.append("columns[" + index + "][searchable]", el.searchable);
        query.append("columns[" + index + "][search][value]", "");
        query.append("columns[" + index + "][search][regex]", "false");
      });
      query.append("search[value]", this.filter);
      query.append("search[regex]", "false");

      query.append(
        "order[0][column]",
        columns.findIndex((field) => field.name == "created_at")
      );
      query.append("order[0][dir]", "desc");

      this.getAll(query)
        .then((response) => {
          if (requestId != this.requestId) return;
          this.totalItemsFiltered = response.data.recordsFiltered;
          this.totalItems = response.data.recordsTotal;

          this.items = response.data.data;
          this.showLoader = false;
          if (!this.items.length && this.currentPage > 1) {
            this.currentPage = Math.max(
              1,
              Math.ceil(this.totalItemsFiltered / this.perPage)
            );
          }
        })
        .catch((error) => {
          if (requestId != this.requestId) return;
          this.handleError(error);
          this.showLoader = false;
        });
    },
    async deleteItem(id) {
      if (await swal.confirm()) {
        swal.loading();
        this.delete(id)
          .then((response) => {
            this.fetchAll();
            swal.success(response.data.message);
          })
          .catch((error) => {
            this.handleError(error);
            swal.close();
          });
      }
    },
    // saveAsPDF
    saveAsPDF() {
      const element = this.$refs.printcontent;
      const fileName = "booth-" + this.project.id + ".pdf";

      html2canvas(element, { scale: 3 })
        .then((canvas) => {
          const imgData = canvas.toDataURL("image/png");
          const pdf = new jsPDF("p", "cm", "a4");
          const height = (canvas.height * 21) / canvas.width;
          let offset = 0;
          do {
            if (offset) pdf.addPage();
            pdf.addImage(imgData, "PNG", 0, -offset, 21, height);
            offset += 29.7;
          } while (offset < height);
          pdf.save(fileName);
        })
        .catch(this.handleError);
    },
    showPDF(id) {
      this.project = this.items.find((s) => s.id == id);
      this.$nextTick(() => this.$bvModal.show("modal-pdf"));
    },
    showStatus(id) {
      this.project = this.items.find((s) => s.id == id);
      this.status = this.project.project_status ? this.project.project_status.id : "";
      this.showModel = true;
      this.$bvModal.show("modal-status");
    },
    resetModal() {
      this.errors = [];
      this.project = "";
      this.status = "";
      this.loadingButton = false;
      this.submited = false;
      this.$v.$reset();
      this.showModel = false;
      this.showAlert = false;
      this.$bvModal.hide("modal-status");
    },
    refreshTable() {
      this.tableKey += 1; // تحديث قيمة المفتاح لإعادة الرندر
    },
    dataChange() {
      return (
        !!this.project &&
        this.status != (this.project.project_status ? this.project.project_status.id : "")
      );
    },
    saveStatus() {
      if (!this.dataChange()) return;

      this.submited = true;
      this.$v.$touch();
      if (this.$v.$error) return;

      // to form submit after this
      this.loadingButton = true;
      this.errors = [];

      let data = {
        id: this.project.id,
        project_status_id: this.status,
      };

      this.updateStatus(data)
        .then((response) => {
          this.fetchAll();
          swal.success(response.data.message);
          this.resetModal();
        })
        .catch((error) => {
          this.handleError(error);
          this.loadingButton = false;
        });
    },
  },
  watch: {
    currentPage: {
      handler: function () {
        this.fetchAll();
      },
    },
    perPage: {
      handler: function () {
        this.search();
      },
    },
  },
  created() {
    this.statuses().catch(this.handleError);
    this.fetchAll();
  },
  mounted() {},
};
</script>

<template>
  <div>
    <!-- start modal-pdf -->
    <b-modal
      id="modal-pdf"
      centered
      title-class="font-18"
      hide-footer
      v-if="typeof project == 'object'"
      @hidden="resetModal"
    >
      <template #modal-title>
        <b-button @click="saveAsPDF" class="btn-sm" variant="info"
          >تحميل الاستمارة بصيغة (pdf)</b-button
        >
      </template>
      <div class="booths-print" ref="printcontent">
        <div class="center">
          <div class="text-center">
            <img
              src="@/assets/images/seda/logo-s.png"
              class="logo mb-3"
              style="width: 130px"
              alt=""
            />
            <!-- <p class="mb-0 font-size-16">سيدة العالم</p> -->
            <p class="mb-3 font-size-12">استمارة معرض المشاريع النسائية 2026</p>
          </div>
          <hr class="hr-title" />
          <div class="break-title"><h5 class="mb-2">بيانات المتقدم</h5></div>
          <div class="row about-list">
            <div class="col-md-6">
              <div class="media">
                <label>الاسم الثلاثي :</label>
                <p>{{ project.full_name }}</p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="media">
                <label>رقم الهاتف :</label>
                <p>{{ project.phone }}</p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="media">
                <label>المحافظة :</label>
                <p>
                  {{
                    project.address && project.address.city
                      ? project.address.city.title
                      : "-"
                  }}
                </p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="media">
                <label>المنطقة :</label>
                <p>{{ project.address ? project.address.region : "-" }}</p>
              </div>
            </div>
          </div>

          <hr class="hr-title" />
          <div class="break-title"><h5 class="mb-2">معلومات المشروع</h5></div>
          <div class="row about-list">
            <div class="col-md-6">
              <div class="media">
                <label>اسم المشروع :</label>
                <p>{{ project.project_name }}</p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="media">
                <label>قطاع المشروع :</label>
                <p>{{ project.category }}</p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="media">
                <label>ملخص فكرة المشروع :</label>
                <p>{{ project.abstract || project.abstuct }}</p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="media">
                <label>تاريخ تأسيس المشروع :</label>
                <p>{{ project.date_ini }}</p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="media">
                <label>ملاحظات :</label>
                <p>{{ project.note }}</p>
              </div>
            </div>
          </div>

          <hr class="hr-title" />
          <div class="break-title"><h5 class="mb-2">معلومات البوث</h5></div>
          <div class="row about-list">
            <div class="col-md-6">
              <div class="media">
                <label>قياس البوث :</label>
                <p>{{ project.model }}</p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="media">
                <label>مكان البوث :</label>
                <p>{{ project.location }}</p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="media">
                <label>حالة القبول :</label>
                <p>{{ project.project_status ? project.project_status.title : "-" }}</p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="media">
                <label>تاريخ التقديم :</label>
                <p>{{ project.created_at }}</p>
              </div>
            </div>
          </div>

          <hr class="hr-title" />
          <div class="break-title"><h5 class="mb-2">مواقع التواصل الاجتماعي</h5></div>
          <div class="row about-list">
            <div class="col-md-6">
              <div class="media">
                <label>انستغرام :</label>
                <p>{{ project.instagram }}</p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="media">
                <label>فيسبوك :</label>
                <p>{{ project.facebook }}</p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="media">
                <label>تيك توك :</label>
                <p>{{ project.tiktok }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- end modal-pdf -->

    <!-- start modal-pdf -->
    <b-modal
      id="modal-status"
      centered
      title="حالة القبول"
      title-class="font-18"
      @hidden="resetModal"
      hide-footer
    >
      <b-form>
        <AlertError
          v-if="showModel"
          :showDismissibleAlert="showAlert"
          :errors="errors"
        ></AlertError>
        <div class="row mt-1">
          <b-form-group
            class="col-md-12 mb-3"
            label="اختر حالة القبول :"
            label-for="status"
          >
            <select
              class="form-control select-p"
              :class="{ 'is-invalid': submited && $v.status.$error }"
              v-model="status"
              size="sm"
            >
              <option v-for="status in getStatuses" :value="status.id" :key="status.id">
                {{ status.title }}
              </option>
            </select>
            <div v-if="submited && $v.status.$error" class="invalid-feedback">
              <span v-if="!$v.status.required"> هذا الحقل الزامي </span>
            </div>
          </b-form-group>
        </div>
        <div class="row mt-3">
          <div class="col-md-12 d-flex justify-content-between">
            <b-button
              :disabled="loadingButton || !this.dataChange()"
              @click="saveStatus()"
              variant="primary"
              type="button"
              class="me-2"
            >
              <b-spinner v-if="loadingButton" small></b-spinner>
              <span v-else
                ><i class="bx bx-check font-size-16 align-middle me-2"></i>حفظ</span
              >
            </b-button>
            <b-button class="" block @click="$bvModal.hide('modal-status')"
              >اغلاق</b-button
            >
          </div>
        </div>
      </b-form>
    </b-modal>
    <!-- end modal-pdf -->

    <Loader :loading="showLoader">
      <div class="row mt-3">
        <div class="col-12">
          <AlertError
            v-if="!showModel"
            :showDismissibleAlert="showAlert"
            :errors="errors"
          ></AlertError>

          <!-- Header Table -->
          <div class="row mt-1">
            <!-- table_length -->
            <div class="col-sm-12 col-md-6">
              <div id="tickets-table_length" class="dataTables_length">
                <label class="d-inline-flex align-items-center">
                  عرض&nbsp;:&nbsp;
                  <b-form-select
                    class="form-select form-select-sm"
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select>
                  &nbsp;مدخلات
                </label>
              </div>
            </div>
            <!-- Search -->
            <div class="col-sm-12 col-md-6">
              <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                <label class="d-inline-flex align-items-center">
                  بحث&nbsp;:&nbsp;
                  <b-form-input
                    v-model="filter"
                    @input="search"
                    type="search"
                    placeholder="بحث..."
                    class="form-control form-control-sm ms-2"
                  ></b-form-input>
                </label>
                <router-link
                  v-can="'export_to_excel_booths'"
                  :to="{ name: 'exportData', query: { form: 'booths' } }"
                  class="btn btn-primary btn-sm mx-2"
                  >Excel</router-link
                >
              </div>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-md-4">
              <label for="booth-status-filter">حالة القبول</label>
              <select
                id="booth-status-filter"
                v-model="statusFilter"
                @change="search"
                class="form-control select-p"
              >
                <option value="">الكل</option>
                <option v-for="status in getStatuses" :key="status.id" :value="status.id">
                  {{ status.title }}
                </option>
              </select>
            </div>
          </div>

          <!-- Table -->
          <div class="table-responsive mb-0">
            <b-table
              class="datatables"
              show-empty
              hover
              :items="items"
              :striped="true"
              :fields="visibleFields()"
              responsive="md"
              :current-page="currentPage"
              :per-page="0"
              :key="tableKey"
            >
              <!-- A virtual column -->
              <template #cell(index)="data">
                {{ data.index + 1 + (currentPage - 1) * perPage }}
              </template>

              <!-- A custom formatted column Status -->
              <template v-slot:cell(status)="data">
                <span
                  class="badge btn-settings-booths rounded-5 p-2"
                  style="width: 75px"
                  :class="
                    data.item.project_status
                      ? statusClassList[data.item.project_status.name]
                      : 'bg-secondary'
                  "
                  >{{
                    data.item.project_status ? data.item.project_status.title : "-"
                  }}</span
                >
              </template>

              <!-- A custom formatted column Sutting -->
              <template v-slot:cell(settings)="data">
                <router-link
                  v-can="'show_details_booths'"
                  :to="{ name: 'booths.details', params: { id: data.item.id } }"
                >
                  <b-button class="btn-sm btn-settings-booths me-1" variant="info"
                    >التفاصيل</b-button
                  >
                </router-link>

                <b-button
                  class="btn-sm btn-settings-booths me-1"
                  v-can="'show_details_booths'"
                  @click="showPDF(data.item.id)"
                  >pdf</b-button
                >

                <b-button
                  v-can="'update_status_booths'"
                  class="btn-sm btn-settings-booths me-1"
                  variant="primary"
                  @click="showStatus(data.item.id)"
                  >حالة القبول</b-button
                >

                <b-button
                  v-can="'delete_booths'"
                  class="btn-sm btn-settings-booths"
                  variant="danger"
                  title="حذف"
                  @click="deleteItem(data.item.id)"
                  ><i class="bx bx-trash"></i
                ></b-button>
              </template>
            </b-table>
          </div>

          <!-- Footer Table -->
          <div class="row">
            <div class="col">
              <div class="dataTables_paginate paging_simple_numbers float-end">
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalItemsFiltered"
                    :per-page="perPage"
                  ></b-pagination>
                </ul>
              </div>
              <div class="dataTables_paginate paging_simple_numbers float-start">
                <p>
                  عرض من {{ start }} الى {{ end }} من مجموع {{ totalItemsFiltered }}
                  <span v-if="totalItemsFiltered != totalItems"
                    >(تمت تصفيته من إجمالي {{ totalItems }} إدخالاً)</span
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Loader>
  </div>
</template>
